import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.define-properties";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
*/
import { FailureMessageBean } from 'wfui-digital-core/es/lib';
var jsonRegex = new RegExp('error parsing json', 'i');
var networkRegex1 = new RegExp('request failed with status code ([0-9]+)', 'i');
var networkRegex2 = new RegExp('network error', 'i');
var timeoutRegex = new RegExp('timeout of [0-9]+ms exceeded', 'i');

var getDetails = function getDetails(result) {
  var reason;
  var statusCode;

  if (jsonRegex.test(result)) {
    reason = 'json';
  } else if (networkRegex1.test(result)) {
    reason = 'network';
    statusCode = networkRegex1.exec(result)[1];
  } else if (networkRegex2.test(result)) {
    reason = 'network';
  } else if (timeoutRegex.test(result)) {
    reason = 'timeout';
  }

  return {
    reason: reason,
    statusCode: statusCode
  };
};

export default (function (jsonPromise) {
  return new Promise(function (resolve, reject) {
    jsonPromise.then(function (result) {
      return resolve(result);
    })["catch"](function (result) {
      reject(FailureMessageBean(_objectSpread({
        message: 'Error communicating with server',
        systemError: true
      }, getDetails(JSON.stringify(result)))));
    });
  });
});